<script>
import resources from './resources'

export default {
  name: 'my-address',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-xl-4.col-lg-6.col-md-6.col-sm-12
    .card
      .header
        h2
          strong Bicicleta
          |   - {{ qt }}
        ul.header-dropdown
          li.dropdown(:class="{'show': actions}")
            a.dropdown-toggle(
              href='javascript:void(0);',
               data-toggle='dropdown',
               role='button',
               aria-haspopup='true',
               aria-expanded='false'
               @click.prevent="viewActions(actions)"
            )
              i.zmdi.zmdi-more
            ul.dropdown-menu.dropdown-menu-righ(
              x-placement='bottom-end',
              style='position: absolute; transform: translate3d(-128px, 32px, 0px); top: 0px; left: 0px; will-change: transform;'
              :class="{'show': actions}"
            )
              li
                router-link.cursor-pointer(:to="{name: 'dweller.bike.edit', params: {id: bike.id, tower_id: bike.tower_id, unit_id: bike.unit_id}}") Editar
              li
                 a(href='javascript:void(0);', @click.prevent="$emit('on-delete', bike)") Excluir
      .body
        h6.m-b-15
          | Bicicletas: {{ bike.rack }}
          span.badge.badge-warning.float-right 00000
            i.zmdi.zmdi-circle.offline(v-if="bike.status === 'false'")
            i.zmdi.zmdi-circle.online(v-if="bike.status === 'true'")

        .row
          .col-5
            small
              strong GARAGEM:

          .col-7
            small
              strong TORRE:
        .row
          .col-5
            span.badge.float-left(
              v-for="g in bike.garage",
              :class="{'badge-success': g.id === bike.garage_id, 'badge-default': g.id !== bike.garage_id}"
              style="margin-right: 5px;"
            )
              | {{g.number}}
          .col-7
            small
              | {{ bike.tower.name}}
        .row
          .col-5
            small
              strong MORADOR:

          .col-7
            small
              strong FONE:
        .row
          .col-5
            img.team-info.cursor-pointer(
              :src='bike.user.image.url',
              :title="bike.user.name",
              :alt='bike.user.name'
              v-if="bike.user.image !== null",
            )
            img.team-info.cursor-pointer(
              src='/static/images/profile_av.jpeg',
              :title="bike.user.name",
              :alt='bike.user.name'
              v-if="bike.user.image === null",
            )
          .col-7
            small {{ maskPhone(bike.user.phone) }}
            br
            small {{ bike.user.name }}


</template>
<style scoped>
  .team-info {
      width: 42px;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      -ms-border-radius: 50%;
      border-radius: 50%;
      border: 2px solid #fff;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
      margin-top: 0px;
  }
  .online {
    margin-left: 10px;
    color: #86BB71;
  }
  .offline {
    margin-left: 10px;
    color: #E38968;
  }
  .online, .offline, .me {
      margin-right: 3px;
      font-size: 10px;
  }
  .material-icons {
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      font-size: 12px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-feature-settings: 'liga';
      -webkit-font-smoothing: antialiased;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/dweller/bike/index/components/item.vue